
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import referenceData from "@/data/reference";
import ApiService from "@/core/services/ApiService";
import { ElNotification } from "element-plus";
import moment from "moment";
import { useRouter } from "vue-router";
import { saveFile } from "@/core/services/FileSaverService";
import store from "@/store";

export default defineComponent({
  name: "reference",
  setup() {
    onMounted(async () => {
      setCurrentPageTitle("Лавлагаа");
    });
    const role = store.getters.getRoleNames as string[];
    const isu = store.getters.getMbUser as boolean;

    return {
      role,
      isu
    };
  },
  data() {
    const router = useRouter();
    const getCustomerDetails = identityno => {
      this.saveReferenceState();
      const id = this.b64EncodeUnicode(identityno);
      router.push({
        name: "refcustomerdetails",
        params: { id: id }
      });
    };

    return {
      getCustomerDetails,
      zmaChecked: false,
      inquiryDownloadButton: "off",
      inquiryLoading: false,
      searchMode: "simple",
      resultSearchMode: "simple",
      resultEntityType: "citizen",
      advancedFieldOptions: {
        citizen: [
          { key: "identityno", label: "ИБД" },
          { key: "registerno", label: "Регистрийн дугаар" },
          { key: "firstname", label: "Нэр" },
          { key: "lastname", label: "Эцгийн нэр" }
        ],
        organization: [
          { key: "registerno", label: "Регистрийн дугаар" },
          { key: "stateregisterno", label: "Улсын бүртгэлийн дугаар" },
          { key: "customername", label: "Хуулийн этгээдийн нэр" },
          { key: "presidentname", label: "Захирлын нэр" },
          { key: "presidentregid", label: "Захирлын регистрийн дугаар" }
        ]
      },
      advanced: {
        subjectType: "citizen",
        connectors: {
          registerno: "and",
          firstname: "and",
          lastname: "and",
          stateregisterno: "and",
          customername: "and",
          presidentname: "and",
          presidentregid: "and"
        },
        values: {
          identityno: "",
          registerno: "",
          firstname: "",
          lastname: "",
          stateregisterno: "",
          customername: "",
          presidentname: "",
          presidentregid: ""
        }
      },
      loadButtonSimple: "off",
      result: false,
      coRelResultCode: -1,
      customerResultCode: -1,
      searchValue: "",
      coSearchValue: "",
      legalStatus: referenceData[0]["legalStatus"],
      value: "01",
      orgFields: referenceData[0]["orgFields"],
      citizenFields: referenceData[0]["citizenFields"],
      val: "cin",
      coStatus: referenceData[0]["coStatus"],
      coValue: "01",
      coFieldsCitizen: referenceData[0]["coFieldsCitizen"],
      coFieldsOrg: referenceData[0]["coFieldsOrg"],
      coVal: "cin",
      searchedValue: "",
      citizenTableData: [],
      orgTableData: [],
      coRelCitizenTableData: [],
      coRelOrgTableData: []
    };
  },
  computed: {
    currentAdvancedFields(): Array<{ key: string; label: string }> {
      const type = this.advanced.subjectType as "citizen" | "organization";
      return this.advancedFieldOptions[type] || [];
    }
  },
  mounted() {
    this.restoreReferenceState();
  },
  methods: {
    saveReferenceState() {
      const stateKeys = [
        "zmaChecked",
        "searchMode",
        "resultSearchMode",
        "resultEntityType",
        "advanced",
        "loadButtonSimple",
        "result",
        "coRelResultCode",
        "customerResultCode",
        "searchValue",
        "coSearchValue",
        "value",
        "val",
        "coValue",
        "coVal",
        "searchedValue",
        "citizenTableData",
        "orgTableData",
        "coRelCitizenTableData",
        "coRelOrgTableData"
      ];
      const state = stateKeys.reduce((acc, key) => {
        acc[key] = (this as any)[key];
        return acc;
      }, {} as Record<string, unknown>);

      sessionStorage.setItem("referenceSearchState", JSON.stringify(state));
      sessionStorage.setItem("referenceSearchStateActive", "1");
    },
    restoreReferenceState() {
      if (sessionStorage.getItem("referenceSearchStateActive") !== "1") {
        return;
      }

      const rawState = sessionStorage.getItem("referenceSearchState");

      if (!rawState) {
        return;
      }

      try {
        const state = JSON.parse(rawState);
        Object.keys(state).forEach(key => {
          if (key in this) {
            (this as any)[key] = state[key];
          }
        });
        sessionStorage.removeItem("referenceSearchStateActive");
      } catch (error) {
        sessionStorage.removeItem("referenceSearchState");
        sessionStorage.removeItem("referenceSearchStateActive");
      }
    },
    setSearchMode(mode) {
      this.searchMode = mode;
      this.resultSearchMode = mode;
      this.resetResultFields();
    },
    handleAdvancedSubjectChange() {
      Object.keys(this.advanced.values).forEach(key => {
        this.advanced.values[key] = "";
      });
      this.resultEntityType = this.advanced.subjectType;
      this.resetResultFields();
    },
    isCitizenResult() {
      if (this.resultSearchMode === "advanced") {
        return this.resultEntityType === "citizen";
      }
      return this.value === "01" || this.value === "02";
    },
    buildAdvancedParams() {
      const filters = this.currentAdvancedFields
        .filter(field => {
          return this.advanced.values[field.key];
        })
        .map((field, index) => {
          return {
            field: field.key,
            value: this.advanced.values[field.key],
            operator: index === 0 ? "and" : this.advanced.connectors[field.key]
          };
        });

      return {
        type: "advanced",
        entityType: this.advanced.subjectType,
        status: this.advanced.subjectType === "citizen" ? "01" : "03",
        values: { ...this.advanced.values },
        connectors: { ...this.advanced.connectors },
        filters
      };
    },
    getAdvancedSearchSummary() {
      return this.currentAdvancedFields
        .filter(field => {
          return this.advanced.values[field.key];
        })
        .map((field, index) => {
          const value = `${field.label}: ${this.advanced.values[field.key]}`;
          if (index === 0) {
            return value;
          }
          return `${this.advanced.connectors[
            field.key
          ].toUpperCase()} ${value}`;
        })
        .join(", ");
    },
    async downloadCreditInquiry(identityno) {
      if (this.inquiryLoading) return;

      this.inquiryLoading = true;
      document.body.classList.add("waiting");

      try {
        const response = await ApiService.post(
          `inquiry/credit-inquiry?identityno=${encodeURIComponent(identityno)}`,
          {
            responseType: "blob"
          }
        );

        const contentType = response?.headers?.["content-type"] || "";

        // backend JSON error буцаасан эсэхийг шалгана
        if (contentType.includes("application/json")) {
          const text = await response.data.text();
          const json = JSON.parse(text);

          ElNotification({
            title: "Алдаа",
            message: json?.error || "Лавлагаа үүсгэхэд алдаа гарлаа.",
            type: "error",
            iconClass: "el-text-error"
          });
          return;
        }

        // PDF нээх
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileURL = window.URL.createObjectURL(blob);

        const now = new Date();

        const timestamp =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, "0") +
          String(now.getDate()).padStart(2, "0") +
          String(now.getHours()).padStart(2, "0") +
          String(now.getMinutes()).padStart(2, "0") +
          String(now.getSeconds()).padStart(2, "0");

        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `zms_inquiry_${identityno}_${timestamp}.pdf`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          window.URL.revokeObjectURL(fileURL);
        }, 1000);
      } catch (error) {
        ElNotification({
          title: "Алдаа",
          message: "Лавлагаа үүсгэхэд алдаа гарлаа.",
          type: "error",
          iconClass: "el-text-error"
        });
      } finally {
        this.inquiryLoading = false;
        document.body.classList.remove("waiting");
      }
    },
    async downloadRelatedCreditInquiry(identityno, loancode) {
      if (this.inquiryLoading) return;

      this.inquiryLoading = true;
      document.body.classList.add("waiting");

      try {
        const response = await ApiService.post(
          `inquiry/related-credit-inquiry?identityno=${encodeURIComponent(
            identityno
          )}&loancode=${encodeURIComponent(loancode)}`,
          {
            responseType: "blob"
          }
        );

        const contentType = response?.headers?.["content-type"] || "";

        // backend JSON error буцаасан эсэхийг шалгана
        if (contentType.includes("application/json")) {
          const text = await response.data.text();
          const json = JSON.parse(text);

          ElNotification({
            title: "Алдаа",
            message: json?.error || "Лавлагаа үүсгэхэд алдаа гарлаа.",
            type: "error",
            iconClass: "el-text-error"
          });
          return;
        }

        // PDF нээх
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileURL = window.URL.createObjectURL(blob);

        const now = new Date();

        const timestamp =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, "0") +
          String(now.getDate()).padStart(2, "0") +
          String(now.getHours()).padStart(2, "0") +
          String(now.getMinutes()).padStart(2, "0") +
          String(now.getSeconds()).padStart(2, "0");

        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `zms_inquiry_related_${identityno}_${timestamp}.pdf`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          window.URL.revokeObjectURL(fileURL);
        }, 1000);
      } catch (error) {
        ElNotification({
          title: "Алдаа",
          message: "Лавлагаа үүсгэхэд алдаа гарлаа.",
          type: "error",
          iconClass: "el-text-error"
        });
      } finally {
        this.inquiryLoading = false;
        document.body.classList.remove("waiting");
      }
    },
    resetResultFieldsLegalStatus() {
      if (this.value === "01" || this.value === "02") {
        this.val = "cin";
      } else {
        this.val = "registerno";
      }

      this.result = false;
      this.coRelResultCode = -1;
      this.customerResultCode = -1;
    },
    resetResultFieldsCoLegalStatus() {
      if (this.coValue === "01") {
        this.coVal = "cin";
      } else {
        this.coVal = "registerno";
      }

      this.result = false;
      this.coRelResultCode = -1;
      this.customerResultCode = -1;
    },
    resetResultFields() {
      this.result = false;
      this.coRelResultCode = -1;
      this.customerResultCode = -1;
    },
    getMomentTime(date) {
      return moment(date).format("yyyy-MM-DD HH:mm");
    },
    async getCustomerRefPdf(customercode) {
      this.inquiryDownloadButton = "on";
      document.body.classList.add("waiting");
      let slug;
      if (this.zmaChecked)
        slug = `?customercode=${customercode}&ischecked=${this.zmaChecked}`;
      else slug = `?customercode=${customercode}`;
      await ApiService.get(`refcustomerpdf`, slug)
        .then(resp => {
          const results = resp.data;
          if (results.code === 0) {
            ElNotification({
              title: "Алдаа",
              message: results.error,
              type: "error",
              iconClass: "el-text-error"
            });
          } else if (results.code === 401) {
            ElNotification({
              title: "Анхааруулга",
              message: results.warning,
              type: "warning",
              iconClass: "el-text-warning"
            });
          } else {
            saveFile(results.response, customercode, "application/pdf", ".pdf");
          }
        })
        .catch(() => {
          ElNotification({
            title: "Алдаа",
            message: "Лавлагаа татхад алдаа гарлаа.",
            type: "error",
            iconClass: "el-text-error"
          });
        })
        .finally(() => {
          document.body.classList.remove("waiting");
          this.inquiryDownloadButton = "off";
        });
    },
    async getCoCustomerReference() {
      this.loadButtonSimple = "on";
      (document.getElementById(
        "searchValueRel"
      ) as HTMLInputElement).setAttribute("disabled", "true");
      const params = {
        type: "custrelation",
        searchValue: this.coSearchValue,
        status: this.coValue,
        searchType: this.coVal
      };
      await ApiService.post("reference", { params })
        .then(res => {
          const results = res.data;
          if (results.code === 0) {
            ElNotification({
              title: "Алдаа",
              message: results.error,
              type: "error",
              iconClass: "el-text-error"
            });
          } else if (results.code === 401) {
            ElNotification({
              title: "Анхааруулга",
              message: results.warning,
              type: "warning",
              iconClass: "el-text-warning"
            });
          } else {
            const custResult = results.response.searchResult;
            this.result = true;
            this.coRelResultCode = custResult.code;
            if (this.coRelResultCode !== 0) {
              if (this.coValue === "01") {
                this.coRelCitizenTableData = custResult.result;
              } else {
                this.coRelOrgTableData = custResult.result;
              }
            } else {
              ElNotification({
                title: "Хамтран зээлдэгч",
                message: "Үр дүн олдсонгүй.",
                type: "info",
                iconClass: "el-text-success"
              });
            }
          }
        })
        .catch(() => {
          ElNotification({
            title: "Алдаа",
            message: "Хамтран зээлдэгч хайхад алдаа гарлаа.",
            type: "error",
            iconClass: "el-text-error"
          });
        })
        .finally(() => {
          (document.getElementById(
            "searchValueRel"
          ) as HTMLInputElement).removeAttribute("disabled");
          this.searchedValue = this.coSearchValue;
          this.customerResultCode = -1;
          this.loadButtonSimple = "off";
        });
    },
    async getAdvancedCustomerReference() {
      const params = this.buildAdvancedParams();

      if (!params.filters.length) {
        ElNotification({
          title: "Warning",
          message: "Please enter at least one advanced search value.",
          type: "warning",
          iconClass: "el-text-warning"
        });
        return;
      }

      this.loadButtonSimple = "on";
      this.resultSearchMode = "advanced";
      this.resultEntityType = this.advanced.subjectType;

      await ApiService.postWithRawBody("reference", { params })
        .then(res => {
          const results = res.data;
          if (results.code === 0) {
            ElNotification({
              title: "Error",
              message: results.error,
              type: "error",
              iconClass: "el-text-error"
            });
          } else if (results.code === 401) {
            ElNotification({
              title: "Warning",
              message: results.warning,
              type: "warning",
              iconClass: "el-text-warning"
            });
          } else {
            const custResult = results.response.searchResult;
            this.result = true;
            this.customerResultCode = custResult.code;
            if (this.customerResultCode !== 0) {
              if (this.resultEntityType === "citizen") {
                this.citizenTableData = custResult.result;
              } else {
                this.orgTableData = custResult.result;
              }
            } else {
              ElNotification({
                title: "Advanced Search",
                message: "No results found.",
                type: "info",
                iconClass: "el-text-info"
              });
            }
          }
        })
        .catch(() => {
          ElNotification({
            title: "Error",
            message: "Advanced search request failed.",
            type: "error",
            iconClass: "el-text-error"
          });
        })
        .finally(() => {
          this.searchedValue = this.getAdvancedSearchSummary();
          this.coRelResultCode = -1;
          this.loadButtonSimple = "off";
        });
    },
    async getCustomerReference() {
      this.loadButtonSimple = "on";
      this.resultSearchMode = "simple";
      this.resultEntityType =
        this.value === "01" || this.value === "02" ? "citizen" : "organization";
      (document.getElementById(
        "searchValueSimple"
      ) as HTMLInputElement).setAttribute("disabled", "true");
      const params = {
        type: "simple",
        searchValue: this.searchValue,
        status: this.value,
        searchType: this.val
      };
      await ApiService.post("reference", { params })
        .then(res => {
          const results = res.data;
          if (results.code === 0) {
            ElNotification({
              title: "Алдаа",
              message: results.error,
              type: "error",
              iconClass: "el-text-error"
            });
          } else if (results.code === 401) {
            ElNotification({
              title: "Анхааруулга",
              message: results.warning,
              type: "warning",
              iconClass: "el-text-warning"
            });
          } else {
            const custResult = results.response.searchResult;
            this.result = true;
            this.customerResultCode = custResult.code;
            if (this.customerResultCode !== 0) {
              if (this.value === "01" || this.value === "02") {
                this.citizenTableData = custResult.result;
              } else {
                this.orgTableData = custResult.result;
              }
            } else {
              ElNotification({
                title: "Зээлдэгч энгийн хайлт",
                message: "Үр дүн олдсонгүй.",
                type: "info",
                iconClass: "el-text-info"
              });
            }
          }
        })
        .catch(() => {
          ElNotification({
            title: "Алдаа",
            message: "Зээлдэгч хайхад алдаа гарлаа.",
            type: "error",
            iconClass: "el-text-error"
          });
        })
        .finally(() => {
          (document.getElementById(
            "searchValueSimple"
          ) as HTMLInputElement).removeAttribute("disabled");
          this.searchedValue = this.searchValue;
          this.coRelResultCode = -1;
          this.loadButtonSimple = "off";
        });
    }
  }
});
